module.exports = __webpack_public_path__ + "static/media/1.1.93eedee2.zip";